// Shared WhatsApp deep-link helper for SN Associates
export const WHATSAPP_NUMBER = '919912740286';

export const waLink = (message) => {
  const text = message
    ? `?text=${encodeURIComponent(message)}`
    : `?text=${encodeURIComponent("Hello SN Associates, I'd like to know more about your accounting & tax services.")}`;
  return `https://wa.me/${WHATSAPP_NUMBER}${text}`;
};
